export const CHOICES = Object.freeze({
  YES: 'yes',
  NO: 'no',
});
